import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as FileSaver from "file-saver";
import { companyTypeList } from "./companyTyplesList";

export const utility = {
  BASE_URL: environment.serverUrl,
  FILE_SERVER: environment.FILE_SERVER,
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': '*/*'
  }),
  noAuthHeaders: new HttpHeaders({
    'No-Auth': 'True',
    'Content-Type': 'application/json'
  }),
}

export function formatName(data: any) {

  let middleName = data.otherName || "";

  let name = (data.surname + " " + data.firstname + " " + middleName).toUpperCase();
  if (data.isCorporate) {
    if (!!data.firstname && !!data.surname) {
      name = (data.surname + " " + data.firstname + " " + middleName + " ON BEHALF OF THE " + data.corporationName + "[" + data.rcNumber + "]").toUpperCase();
    }
    else {
      name = (data.corporationName + "[" + data.rcNumber + "]").toUpperCase();
    }
  }
  return name;
}


export function formatAddress(row: any, countryList?: any) {
  let address = "";
  if (row.streetNumber != null && row.streetNumber.length > 0) {
    address += row.streetNumber + ", ";
  }
  if (row.address != null && row.address.length > 0) {
    address += row.address + ", ";
  }
  if (row.city != null && row.city.length > 0) {
    address += row.city + ", ";
  }

  if (row.state != null && row.state.length > 0) {
    address += row.state.indexOf("FCT") > -1 ? row.state + ", " : row.state + " STATE, ";
  }
  if (!!countryList && !!row.country_fk && !!row.country_fk.id) {
    let country = countryList.filter(c=>{
      c.id == row.country_fk.id;
    });
    if (country[0]) {
      address += country[0].name;
    }
  }
  else if (row.nationality) {
    address += row.nationality;
  }
  else{
    address += "NIGERIA";
  }
  address = address.replace(",,", ",");
  return address;
}


export function formatNameSubscribers(data: any) {
  if (data==null){
    return ""
  }
  let middleName = data.otherName || "";
  if (data.isCorporate) {
    return (data.corporationName + "[" + data.rcNumber + "]").toUpperCase();
  }
  else{
    return (data?.surname + " " + data?.firstname + " " + middleName).toUpperCase();
  }
}

export class Utils {

  static isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  static saveBlob(blob: any, fileName: string): void {
    if (fileName) {
      FileSaver.saveAs(blob, fileName);
    }
  }

  static getProcessType(classificationId: number): number {
    let processType: number;
    if(classificationId == 1){
      processType = 6123
    } else if(classificationId == 2) {
      processType = 6564
    } else if (classificationId == 3) {
      processType = 6565
    } else if (classificationId == 4) {
      processType = 21538
    } else if (classificationId == 5) {
      processType = 21539
    } else {
      return -1;
    }
    return processType;
  }

  static getProcessTypeAsString(classificationId: number): string {
    const result: number = Utils.getProcessType(classificationId);
    if(result > 0) {
      return result.toString();
    }
    return;
  }

  static getCompanyType(company: any): any {
    let companyType: any;
    if(company?.companyTypeFkId) {
      companyType = companyTypeList.filter((a): boolean => {
        return a.id == company?.companyTypeFkId;
      })[0];
    } else if (company?.companyTypeObj) {
      companyType = company?.companyTypeObj;
    } else if (company?.companyType) {
      if(typeof company?.companyType === "number") {
        companyType = companyTypeList.filter((a): boolean => {
          return a.id == company?.companyTypeFkId;
        })[0];
      } else {
        companyType = company?.companyType;
      }
    }
    return companyType;
  }
}
